import { Controller, useWatch } from 'react-hook-form'

import { RECIPE_LIMITS, maxLengthCheck } from '../utils/recipeLimits'
import { DeleteIcon } from './SvgIcon'
import InputSimple from './InputSimple'
import FieldFeedback from './FieldFeedback'

// One ingredient row: amount, unit and ingredient. Any problem shows under the whole row.
const IngredientsItem = ({ index, control, remove, errors }) => {
  const number = index + 1
  const rowErrors = errors?.ingredients?.[index] || {}
  const name = useWatch({ control, name: `ingredients.${index}.name` })

  return (
    <div data-field>
      <div className="ingredientsWrap">
        <div className="ingredientsCount">
          <Controller
            name={`ingredients.${index}.quantity`}
            rules={{
              validate: {
                maxLength: maxLengthCheck(
                  `The amount for ingredient ${number}`,
                  RECIPE_LIMITS.ingredientQuantity.max
                ),
              },
            }}
            control={control}
            defaultValue=""
            render={({ field, fieldState }) => (
              <InputSimple
                {...field}
                {...fieldState}
                showErrorText={false}
                nameInputPlaceholder="Amount"
                styleInput="inputRecipeNumber numberInputCustom"
                className="ingredientsNumber"
              />
            )}
          />
          <Controller
            name={`ingredients.${index}.measurement`}
            rules={{
              validate: {
                maxLength: maxLengthCheck(
                  `The unit for ingredient ${number}`,
                  RECIPE_LIMITS.ingredientMeasurement.max
                ),
              },
            }}
            control={control}
            render={({ field, fieldState }) => (
              <div className="wrapDropTbl">
                <InputSimple
                  {...field}
                  {...fieldState}
                  showErrorText={false}
                  nameInputPlaceholder="Unit"
                  styleInput="inputRecipeNumber numberInputCustom"
                  className="dropSecondStep"
                />
              </div>
            )}
          />
        </div>
        <Controller
          name={`ingredients.${index}.name`}
          control={control}
          defaultValue=""
          rules={{
            validate: {
              maxLength: maxLengthCheck(`Ingredient ${number}`, RECIPE_LIMITS.ingredientName.max),
            },
          }}
          render={({ field, fieldState }) => (
            <div className="ingredientsCount">
              <InputSimple
                {...field}
                {...fieldState}
                showErrorText={false}
                nameInputPlaceholder="Ingredient, for example flour"
                styleInput="inputRecipeNumber"
                className="ingredientsName"
              />
              <div
                className={`innerDeleteIngredient ${index === 0 ? 'hideButtonRemove' : ''}`}
                onClick={() => remove(index)}
              >
                <DeleteIcon />
              </div>
            </div>
          )}
        />
      </div>
      <FieldFeedback
        error={rowErrors.quantity || rowErrors.measurement || rowErrors.name}
        value={name}
        max={RECIPE_LIMITS.ingredientName.max}
        label={`Ingredient ${number}`}
      />
    </div>
  )
}

export default IngredientsItem
